






import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class InvoiceRow extends Vue {
  @Prop({ required: true }) styleGridColumn!: string;

  get style() {
    return {
      "grid-template-columns": this.styleGridColumn
    };
  }
}
